/**
 * Zeitstempel vom Server in ein Date umwandeln.
 *
 * Das Backend liefert Zeitpunkte seit der Umstellung mit Zonenkennzeichnung
 * (`…Z`); der Browser rechnet sie dann selbst in die Zeitzone des Anwenders um
 * und `new Date(wert)` genügt. Fehlt die Kennzeichnung – etwa bei Werten aus
 * einer Fremdschnittstelle – deutet JavaScript den Wert als Ortszeit und zeigt
 * eine UTC-Zahl unverändert an, im Sommer also zwei Stunden zu früh. Für diesen
 * Fall wird ein `Z` ergänzt.
 *
 * Bewusst NICHT blind `+ 'Z'`: bei einem Wert, der bereits eine Zone trägt,
 * ergäbe das ein ungültiges Datum.
 */
export function parseServerDate(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const text = String(value).trim();

  // Endet auf Z, oder trägt ein Offset wie +02:00 / -0500 nach der Uhrzeit.
  const hatZone = /[Zz]$/.test(text) || /[+-]\d{2}:?\d{2}$/.test(text);

  const datum = new Date(hatZone ? text : text + 'Z');
  return isNaN(datum.getTime()) ? null : datum;
}

/** Millisekunden seit Epoch, oder NaN wenn der Wert unbrauchbar ist. */
export function serverDateMillis(value: string | Date | null | undefined): number {
  const datum = parseServerDate(value);
  return datum ? datum.getTime() : NaN;
}
